import { Typography } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';

import type { ResourcesScopeType } from '@/components/resourcesSelection/resourceSelectionDynamicViewer';
import { Wizard } from '@/components/wizard/Wizard';
import {
  createAllExcludedCondition,
  createAllIncludedCondition,
} from '@/types/advanceFilter';

import {
  RansomwareByConditionFlow,
  type RansomwareByConditionState,
} from './ransomwareByConditionFlow';

interface RansomwareByConditionPanelProps {
  condition?: Condition;
  resourcesScopeType: ResourcesScopeType;
  include?: string[];
  exclude?: string[];
  onSave: (
    condition: Condition,
    include: string[],
    exclude: string[]
  ) => Promise<void>;
  onAbort: () => void;
}

export function RansomwareByConditionPanel(
  props: RansomwareByConditionPanelProps
) {
  const onFinish = async (state: RansomwareByConditionState) => {
    const condition =
      state.resourcesScopeType === 'allIncluded'
        ? createAllIncludedCondition()
        : state.resourcesScopeType === 'allExcluded'
          ? createAllExcludedCondition()
          : state.condition;

    if (condition) {
      await props.onSave(
        {
          ...condition,
        },
        state.include,
        state.exclude
      );
      return true;
    }

    return false;
  };

  return (
    <Wizard<RansomwareByConditionState>
      hideBorder={false}
      onAbort={props.onAbort}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[RansomwareByConditionFlow]}
      initialState={{
        condition: props.condition,
        resourcesScopeType: props.resourcesScopeType,
        include: props.include ?? [],
        exclude: props.exclude ?? [],
        editMode: !!props.condition,
      }}
      title={props.condition ? 'Edit Conditions' : 'Create Conditions'}
      subtitle={
        <Typography variant='body1'>
          Create dedicated detection rules based on resource properties, like
          data classes, environment,
          <br />
          or tags. Matching backed-up resources will be checked for ransomware.
        </Typography>
      }
    />
  );
}
